import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './calendar.types';
import * as constants from './calendar.constants';

export const calendarReducer = generateResourceReducer<types.ICalendar>({
  STORE: constants.STORE_CALENDAR,
  CLEAR: constants.CLEAR_CALENDAR,
});
